import { Button } from '@usitsdasdesign/dds-react';
import Actions from 'molecules/Actions';
import AlertModal from 'molecules/AlertModal';
import FiltersAndSort from 'molecules/FiltersAndSort';
import Toast from 'molecules/Toast';
import { useSession } from 'next-auth/react';
import SaveFilterModal from 'organisms/SaveFilterModal';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ExportCSV from './ExportCSV';
import SavedFilters from './SavedFilters';

function ActionsWithFilter({
    actionItems = [],
    isTotalCount = false,
    totalCountText,
    filterItems = [],
    sortItems = [],
    searchFilterItems = [],
    onFilterChange,
    onHandleFavList,
    title,
    defaultFilter,
    selectedFilterId,
    view = 'projects',
    FilterService,
    isFav = true,
    isSearch = true,
    isFilterDisabled = false,
    filterSearchFor,
    showSort = true,
    titleType,
    disableSave = false,
    checkFavList = false,
    titleActionDrop,
    isShowTiersScenarios = false,
    onExport = () => false,
    isExport = false,
    isExportAlert = false,
    customMessage,
    filterSearchValue = null,
    entityId = null,
    isShowFilter = true,
    contextPosition,
    isShowFilterSearch,
    fromInsights = false,
    onClearAllFiltersAddon = () => false,
    isBulkUpload = false,
    onBulkUpload = () => false,
    isExportDisabled = false,
    isDisablePagination = false,
    moreActionRight,
    moreActionLeft,
    isSearchWithTag = false,
    isBulkUploadDemand = false,
    onBulkUploadDemand = () => false,
    isInsideDrawer = false,
    wrapperClass = "",
    filterWrapper = "",
    isShowViewToggle = false,
    currentView = 'grid',
    onViewChange = () => false,
    showIconOnly = false
}) {
    const [filters, setFilters] = useState(filterItems);
    const session = useSession();
    const [sorts, setSorts] = useState(sortItems);
    const [showSearchFilter, setShowSearchFilter] = useState(false);
    const [showSaveFilterDialog, setShowSaveFilterDialog] = useState(false);
    const [showSavedFilters, setShowSavedFilters] = useState(false);
    const [savedFilters, setSavedFilters] = useState([]);
    const [selectedSavedFilter, setSelectedSavedFilter] = useState(null);
    const [isDisabledSaveBtn, setIsDisabledSaveBtn] = useState(true);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        variant: 'success'
    });

    const [alert, setAlert] = useState({
        show: false,
        title: '',
        description: '',
        onSave: () => setAlert({ show: false }),
        onClose: () => setAlert({ show: false })
    });

    const [error, setError] = useState(null);


    const handleFilterSelection = async (item) => {
        if (item.isActive) {
            onRemoveFilter(item);
            return;
        }
        let updatedFilters = filters.map((filter) => (filter.id === item.id ? { ...filter, ...item, isActive: !filter.isActive } : filter));
        if (item?.name === 'filters.cecRoleAvlRept') {
            let [cecRoleAvlRept] = filters.filter(item => item?.name === 'filters.cecStatus' && !item?.isActive)
            if (cecRoleAvlRept) {
                updatedFilters = updatedFilters.map((filter) => (filter.id === cecRoleAvlRept.id ? { ...filter, ...cecRoleAvlRept, isActive: !filter.isActive } : filter));
            }
        }
        setFilters(updatedFilters);
    };


    const handleSortSelection = (item) => {
        if (item.isActive) {
            onRemoveSort(item);
            return;
        }
        const updatedSorts = sorts.map((sort) => (sort.id === item.id ? { ...sort, isActive: !sort.isActive } : sort));
        setSorts(updatedSorts);
    };

    const {
        register, control, reset, setValue, watch, unregister, getValues
    } = useForm({
        defaultValues: {
            filterSearchFor: filterSearchFor || {
                label: 'All',
                value: 'all'
            },
            filters: defaultFilter,
            filterSearch: filterSearchValue
        }
    });

    const filtersAdded = filters.filter((filter) => filter.isActive);
    const sortingAdded = sorts.filter((sort) => sort.isActive);

    const onRemoveFilter = (item) => {
        if (fromInsights && (item?.name === 'filters.demandStatus' || item?.name === 'filters.requisitionStatus')) return;
        setValue(item.name, undefined);
        unregister(item.name);
        let updatedFilters = filters.map((filter) => (filter.id === item.id ? { ...filter, ...item, isActive: !filter.isActive } : filter));
        if (item?.name === 'filters.cecStatus') {
            let [cecRoleAvlRept] = filters.filter(item => item?.name === 'filters.cecRoleAvlRept' && item?.isActive)
            if (cecRoleAvlRept) {
                updatedFilters = filters.map((filter) => (filter.id === cecRoleAvlRept.id ? { ...filter, ...cecRoleAvlRept, isActive: !filter.isActive } : filter));
            }
        }

        setFilters(updatedFilters);
        if (!watch('filters')) {
            setSavedFilters(savedFilters.map((filter) => ({ ...filter, isSelected: false })));
            setSelectedSavedFilter(null);
        }

        if (!watch('filters') || watch('filters') === undefined || Object.keys(watch('filters')).length === 0) setValue('filterSearch', null);
        onApply();
    };

    const onRemoveSort = (item) => {
        setValue(item.name, undefined);
        unregister(item.name);
        const updatedSorts = sorts.map((sort) => (sort.id === item.id ? { ...sort, isActive: !sort.isActive } : sort));
        setSorts(updatedSorts);
        onApply();
    };

    const onClearAllFilters = () => {
        setValue('filters', {});
        unregister('filters');
        setFilters(filters.map((filter) => ({ ...filter, isActive: false })));
        setValue('filterSearch', '');
        setShowSearchFilter(false);
        setValue('filterSearchFor', filterSearchFor || { label: 'All', value: 'all' });
        setSelectedSavedFilter(null);
        setSavedFilters(savedFilters.map((filter) => ({ ...filter, isSelected: false })));
        onClearAllFiltersAddon();
        onApply();
    };

    const onClearAllFiltersValues = () => {
        setValue('filters', {});
        unregister('filters');
        setFilters(filters.map((filter) => ({ ...filter, isActive: false })));
        setValue('filterSearch', '');
        setShowSearchFilter(false);
        setValue('filterSearchFor', filterSearchFor || { label: 'All', value: 'all' });
        setSelectedSavedFilter(null);
        setSavedFilters(savedFilters.map((filter) => ({ ...filter, isSelected: false })));
        setValue('sort', {});
        setSorts(sorts.map((sort) => ({ ...sort, isActive: false })));
    };

    const onClearAllSorts = () => {
        setValue('sort', {});
        unregister('sort');
        setSorts(sorts.map((sort) => ({ ...sort, isActive: false })));
        onApply();
    };

    const onApply = (selectedFilterId) => {
        onFilterChange(watch(), selectedFilterId);
    };

    useEffect(() => {
        if (defaultFilter) {
            const updatedFilters = filters.map((filter) => (defaultFilter[filter.name.replace('filters.', '')] ? { ...filter, isActive: !filter.isActive } : filter));
            setFilters(updatedFilters);
        }
        window.onClearAllFilters = onClearAllFiltersValues;
    }, [defaultFilter]);

    const fixedActionItems = [
        ...(isShowFilter
            ? [{
                icon: 'filter__l__stroke',
                label: !showIconOnly ? 'Filter' : '',
                kind: 'secondary',
                isDisabled: isFilterDisabled,
                color: 'dark',
                type: 'filter',
                onClick: (e) => false,
                ariaLabel: 'ButtonWithContext',
                className: `only-icon-mobile btn-sm-mobile ${filtersAdded.length > 0 && '!bg-neutral-400'}`,
            }] : []
        ),

    ];

    if (showSort) {
        fixedActionItems.push(
            {
                icon: 'arrange_vertically__l__stroke',
                label: !showIconOnly ? 'Sort' : '',
                kind: 'secondary',
                color: 'dark',
                ariaLabel: 'icon',
                onClick: (e) => false,
                ariaLabel: 'ButtonWithContext',
                className: `only-icon-mobile btn-sm-mobile ${sortingAdded.length > 0 && '!bg-neutral-400'}`,
                type: 'sorting'
            }
        );
    }


    if (isFav) {
        fixedActionItems.push(
            {
                icon: 'bookmark__l__stroke',
                label: 'Fav List',
                kind: 'primary',
                color: checkFavList ? 'blue' : 'dark',
                onClick: (e) => onHandleFavList(e),
                ariaLabel: 'Button',
                className: 'only-icon-mobile btn-sm-mobile'
            }
        );
    }

    if (isSearch) {
        fixedActionItems.push(
            {
                kind: 'secondary',
                color: 'green',
                label: !showIconOnly ? 'Search' : '',
                icon: 'search__l__stroke',
                className: 'ml-2',
                ariaLabel: 'Button',
                className: `only-icon-mobile btn-sm-mobile ${showSearchFilter && '!bg-neutral-400'}`,
                onClick: () => setShowSearchFilter(true),
                isDisabled: filtersAdded.length > 0
            }
        );
    }

    if (isShowViewToggle) {
        fixedActionItems.push(
            {
                icon: 'grid__l__stroke',
                kind: 'secondary',
                color: currentView === 'grid' ? 'green' : 'grey',
                onClick: () => onViewChange('grid'),
                ariaLabel: 'icon',
                className: `only-icon-mobile btn-sm-mobile border md:w-10 md:h-10 flex items-center justify-center pl-1 ${currentView === 'grid' ? '!border-green-900' : '!border-black'}`,
                type: 'view-toggle'
            },
            {
                icon: 'list__l__stroke',
                kind: 'secondary',
                color: currentView === 'tabular' ? 'green' : 'grey',
                onClick: () => onViewChange('tabular'),
                ariaLabel: 'icon',
                className: `hidden md:flex only-icon-mobile btn-sm-mobile border md:w-10 md:h-10 flex items-center justify-center pl-1 ${currentView === 'tabular' ? '!border-green-900' : '!border-black'}`,
                type: 'view-toggle'
            }
        );
    }

    if (isBulkUpload) {
        if (!actionItems.filter((i) => i.label === 'Bulk upload').length) {
            actionItems.unshift(
                {
                    id: 21,
                    label: 'Bulk upload',
                    ariaLabel: 'Component',
                    component: <Button
                        size='l'
                        icon='download__l__stroke'
                        kind='primary'
                        label='Bulk upload'
                        onClick={onBulkUpload}
                        className='only-icon-mobile btn-sm-mobile'
                    />
                }
            );
        }
    }
    if (isBulkUploadDemand) {
        if (!actionItems.filter((i) => i.label === 'Bulk Upload').length) {
            actionItems.unshift(
                {
                    id: 22,
                    label: 'Bulk Upload',
                    ariaLabel: 'Component',
                    component: <Button  
                        size='l'
                        icon='download__l__stroke'
                        kind='primary'
                        label='Bulk Upload'
                        onClick={onBulkUploadDemand}
                        className='only-icon-mobile'
                     />
                }
            );
        }
    }
    if (isExport) {
        if (!actionItems.filter((i) => i.label === 'Export').length) {
            actionItems.unshift(
                {
                    id: 20,
                    label: 'Export',
                    ariaLabel: 'Component',
                    component: <ExportCSV onExport={onExport} isExportAlert={isExportAlert} customMessage={customMessage} isExportDisabled={isExportDisabled}
                        showIconOnly={showIconOnly} />
                }
            );
        }
    }

    if (isShowTiersScenarios) {
        fixedActionItems.unshift(
            {
                label: 'Tiers and Scenarios',
                kind: 'primary',
                isDisabled: false,
                color: 'blue',
                // if pdf not opened in new tab (external-pdf-link) then add a flag ...scenarios.pdf&download=false
                // remove PDF file after integration
                onClick: (e) => window.open('/docs/integration-tier-and-scenarios.pdf'),
                ariaLabel: 'Button',
                className: 'btn-sm-mobile'
            },
        );
    }

    const onSavedFilterSelect = (data) => {
        const selectedFilterData = data.filters.reduce((acc, filter) => ({ ...acc, [filter.key]: filter.values }), {});
        const updatedFilterItems = filters.map((filter) => ({ ...filter, isActive: selectedFilterData[filter.name.replace('filters.', '')] }));
        const updatedSavedFilters = savedFilters.map((savedFilter) => ({ ...savedFilter, isSelected: savedFilter.id === data.id }));
        setSelectedSavedFilter({ ...data });
        setValue('filters', selectedFilterData);
        setFilters(updatedFilterItems);
        setSavedFilters(updatedSavedFilters);
        setShowSavedFilters(false);
        onApply(data.id);
    };

    const onSaveFilter = async (data, isDefault, existingFilter) => {
        const filterData = {
            name: data.filterName,
            userId: session?.data?.user?.id,
            view,
            filters: data.filters,
            isDefault,
            entityId
        };
        let res;
        if (existingFilter) {
            res = await FilterService.updateFilter(existingFilter.id, filterData);
        } else {
            res = await FilterService.createFilter(filterData);
        }
        if (res.status) {
            const responseEnitity = existingFilter ? res.entity[1] : res.entity;
            setToast({
                ...toast,
                show: true,
                message: `Filter ${data.filterName}  ${existingFilter ? 'updated' : 'added'} successfully`
            });
            setShowSaveFilterDialog(false);
            setError(null);
            let updatedSavedFilters = savedFilters.map((savedFilter) => ({ ...savedFilter, isSelected: false, isDefault: isDefault ? false : savedFilter.isDefault }));
            if (existingFilter) {
                updatedSavedFilters = updatedSavedFilters.filter((savedFilter) => savedFilter.id !== existingFilter.id);
            }
            const savedFilter = {
                ...responseEnitity,
                isSelected: true,
                filters: convertFiltersToFilterArray(data.filters)
            };
            setSavedFilters([savedFilter, ...updatedSavedFilters]);
            setSelectedSavedFilter(savedFilter);
        } else {
            setError(res?.error?.response?.data?.message);
        }
    };

    const onFilterDelete = async (item) => {
        const res = await FilterService.deleteFilter(item.id);
        if (res.status) {
            setToast({
                ...toast,
                show: true,
                message: 'Filter deleted successfully'
            });
            if (selectedSavedFilter?.id === item.id) {
                onClearAllFilters();
            }
            setSavedFilters(savedFilters.filter((savedFilter) => savedFilter.id !== item.id));
        }
    };

    const onMakeDefaultFilter = async (item) => {
        const userId = session?.data?.user?.id;
        const res = await FilterService.markAsDefaultFilter(item.id, userId, view);
        if (res.status) {
            setToast({
                ...toast,
                show: true,
                message: 'Filter marked as default successfully'
            });
            setShowSavedFilters(false);
            setSavedFilters(savedFilters.map((savedFilter) => (savedFilter.id === item.id ? { ...savedFilter, isDefault: true } : { ...savedFilter, isDefault: false })));
        }
    };

    const convertFiltersToFilterArray = (selectedFilters) => filters.filter((filter) => selectedFilters[filter.name.replace('filters.', '')]).map((filter) => {
        const filterKey = filter.name.replace('filters.', '');
        return {
            key: filterKey,
            name: filter.name,
            title: filter.label,
            values: selectedFilters[filterKey]
        };
    });

    const fetchAndSetSavedFilters = async () => {
        const userId = session?.data?.user?.id || session?.user?.id;
        const res = await FilterService.getFilters(userId, view, entityId);
        if (res.status) {
            const updatedSavedFilters = res.entity.map((filter) => ({
                ...filter,
                isSelected: defaultFilter && (selectedFilterId ? (selectedFilterId === filter.id) : filter.isDefault),
                filters: convertFiltersToFilterArray(filter.filters)
            }));
            setSavedFilters(updatedSavedFilters);
            setSelectedSavedFilter(updatedSavedFilters.find((savedFilter) => savedFilter.isSelected));
        }
    };

    const searchEmployee = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const employeeCode = queryParams.toString().split('=')[1];
        const employeeCodeKey = queryParams.toString().split('=')[0];
        if (employeeCodeKey === 'employeeCode' && employeeCode && employeeCode.length) {
            setShowSearchFilter(true);
            setValue('filterSearchFor', { label: 'Employee Code', value: 'employeeCode' });
            setValue('filterSearch', employeeCode);
            onApply();
        }
    };

    useEffect(() => {
        if (FilterService?.getFilters) {
            fetchAndSetSavedFilters();
        }
    }, [FilterService]);


    useEffect(() => {
        if (filters?.cecStatus) {
            let cecStatusValues = getValues('filters.cecStatus')
            if (cecStatusValues?.length === 0) setValue('filters.cecRoleAvlRept', [])
            let cecRolesValues = getValues('filters.cecRoleAvlRept')
            let newCvcRole = []
            for (let i = 0; i < cecRolesValues?.length; i++) {
                let statusCode = cecRolesValues[i]?.['ParentPicklist Value.External Code'];
                if (cecStatusValues.some(item => item.value === statusCode)) newCvcRole.push(cecRolesValues[i])
            }
            setValue('filters.cecRoleAvlRept', newCvcRole)
        }
    }, [getValues('filters.cecStatus')]);

    let timeout;

    useEffect(() => {
        if (toast.show) {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setToast({
                    show: false,
                    message: ''
                });
            }, 2000);
        }
    }, [toast.show]);

    useEffect(() => {
        searchEmployee();
    }, []);



    return (
        <>
            <Actions
                title={title}
                titleType={titleType}
                fixedActionItems={fixedActionItems}
                actionItems={actionItems}
                isTotalCount={isTotalCount}
                totalCountText={totalCountText}
                filters={filters.filter(f => !f.onlySearch || watch('filterSearch'))}
                sortItems={sorts}
                handleFilterSelection={handleFilterSelection}
                handleSortSelection={handleSortSelection}
                onShowSavedFilters={() => setShowSavedFilters(true)}
                titleActionDrop={titleActionDrop}
                contextPosition={contextPosition}
                disableSave={disableSave}
                moreActionRight={moreActionRight}
                moreActionLeft={moreActionLeft}
                wrapperClass={wrapperClass}
                filterWrapper={filterWrapper}
            >
                {
                    (!!filterSearchValue || filtersAdded.length > 0 || showSearchFilter) && (
                        <FiltersAndSort
                            disableSave={disableSave}
                            type={showSearchFilter ? 'search' : 'filter'}
                            fields={filtersAdded}
                            filters={filters.filter(f => !f.onlySearch || watch('filterSearch'))}
                            setFilters={setFilters}
                            onItemsSelect={handleFilterSelection}
                            register={register}
                            control={control}
                            watch={watch}
                            setValue={setValue}
                            onRemove={onRemoveFilter}
                            onClearAll={onClearAllFilters}
                            searchFilterItems={searchFilterItems}
                            onSearch={onApply}
                            onApply={onApply}
                            isDisabledSaveBtn={isDisabledSaveBtn}
                            onSaveFilter={() => {
                                const onSaveFilterHandler = (update) => {
                                    setSelectedSavedFilter({ ...selectedSavedFilter, update });
                                    setShowSaveFilterDialog(true);
                                    setAlert({ show: false });
                                };
                                if (savedFilters.length === 0 || !selectedSavedFilter) {
                                    setShowSaveFilterDialog(true);
                                    return;
                                }
                                setAlert({
                                    show: true,
                                    title: 'Save Filter',
                                    description: <span>Do you want to update the selected saved filter or add a new one?<br /><br />Click Yes to update and No to create a new one</span>,
                                    onClose: () => setAlert({ show: false }),
                                    onCancel: () => onSaveFilterHandler(false),
                                    onSave: () => onSaveFilterHandler(true)
                                });
                            }}
                            onShowSavedFilters={() => setShowSavedFilters(true)}
                            isFilterDisabled={isFilterDisabled}
                            isShowFilter={isShowFilter}
                            isShowFilterSearch={isShowFilterSearch}
                            className='mt-4'
                            isDisablePagination={isDisablePagination}
                            isSearchWithTag={isSearchWithTag}
                            isInsideDrawer={isInsideDrawer}
                        />
                    )
                }

                {
                    sortingAdded.length > 0 && (
                        <FiltersAndSort
                            disableSave={disableSave}
                            type='sorting'
                            fields={sortingAdded}
                            filters={sorts}
                            setFilters={setFilters}
                            onItemsSelect={handleSortSelection}
                            register={register}
                            control={control}
                            watch={watch}
                            setValue={setValue}
                            onRemove={onRemoveSort}
                            onClearAll={onClearAllSorts}
                            className='mt-4'
                            onApply={onApply}
                            isInsideDrawer={isInsideDrawer}
                        />
                    )
                }
            </Actions>
            <SaveFilterModal
                show={showSaveFilterDialog}
                onClose={() => { setError(null); setShowSaveFilterDialog(false); }}
                onSave={(data) => {
                    const saveFilter = (isDefault) => {
                        const existingFilter = selectedSavedFilter?.update ? selectedSavedFilter : null;
                        onSaveFilter({ ...watch(), filterName: data.filterName }, isDefault, existingFilter);
                        setAlert({ show: false });
                    };
                    if (savedFilters.length === 0 || (selectedSavedFilter?.update && selectedSavedFilter.isDefault)) {
                        saveFilter(true);
                        return;
                    }
                    setAlert({
                        show: true,
                        title: 'Mark filter as default',
                        description: 'Do you want to mark this filter as default?',
                        onClose: () => setAlert({ show: false }),
                        onCancel: () => saveFilter(false),
                        onSave: () => saveFilter(true)
                    });
                }}
                defaultFilterName={selectedSavedFilter?.update ? selectedSavedFilter.name : ''}
                error={error}
            />
            <SavedFilters
                show={showSavedFilters}
                data={savedFilters}
                onMakeDefaultFilter={onMakeDefaultFilter}
                onFilterDelete={(item) => {
                    setAlert({
                        show: true,
                        title: 'Delete filter',
                        description: 'Do you want to delete this filter?',
                        onClose: () => {
                            setAlert({ show: false });
                        },
                        onSave: () => {
                            onFilterDelete(item);
                            setAlert({ show: false });
                        }
                    });
                }}
                onClose={() => setShowSavedFilters(false)}
                onSavedFilterSelect={onSavedFilterSelect}
            />
            {
                toast.show && (
                    <Toast
                        message={toast.message}
                        show={toast.show}
                        variant={toast.variant}
                        onClose={() => setToast({ show: false })}
                    />
                )
            }
            <AlertModal
                show={alert.show}
                title={alert.title}
                description={alert.description}
                onClose={alert.onClose}
                cancelLabel='No'
                saveLabel='Yes'
                onSave={alert.onSave}
                onCancel={alert.onCancel}
            />
        </>
    );
}

export default ActionsWithFilter;
